import React from 'react';
// Modules
import Modal from 'react-bootstrap/Modal';

export default function DefaultModal({ title, showModal, handleCloseModal, children }) {
  return (
    <Modal show={showModal} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}
